import { render, staticRenderFns } from "./MiraComparisonCard.vue?vue&type=template&id=458a4ecd&scoped=true&"
import script from "./MiraComparisonCard.vue?vue&type=script&lang=ts&"
export * from "./MiraComparisonCard.vue?vue&type=script&lang=ts&"
import style0 from "./MiraComparisonCard.vue?vue&type=style&index=0&id=458a4ecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a4ecd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular})
